import React from "react";
import { closeIcon } from "../assets";

const Modal = ({
  isOpen,
  onClose,
  title = "Modal Title",
  iconSrc,
  children,
  maxWidth = "max-w-4xl",
}) => {
  if (!isOpen) return null;

  const getIconAlt = (src) => {
    if (!src) return "icon";
    const parts = src.split("/").pop()?.split(".")[0];
    return parts ? parts.replace(/[-_]/g, " ") : "icon";
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div
        className={`bg-white rounded-xl shadow-xl w-full ${maxWidth} max-h-[90vh] overflow-y-auto`}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-[#4154C9]">
          <div className="flex items-center gap-2 text-white text-lg font-semibold">
            {iconSrc && (
              <img
                src={iconSrc}
                alt={getIconAlt(iconSrc)}
                className="h-7 w-7 object-contain"
              />
            )}
            {title}
          </div>
          <button onClick={onClose}>
            <img
              src={closeIcon}
              alt="closeIcon"
              className="h-5 w-5 object-contain hover:opacity-70"
            />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-4">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
